/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import type { IntegrationState, IntegrationType } from 'embercom/objects/standalone/constants';

export default class DeployChannel extends Model {
  @attr('number') declare integrationType: IntegrationType;
  @attr('number') declare status: IntegrationState;
}
